/**
 * Route definitions for the Equipments module.
 * Lazily loads page components for equipment list and equipment details.
 */
import createFeatureRoutes from '@/common/presentation/components/MainRouteHelper/MainRouteHelper';

const EquipmentRoutes = createFeatureRoutes(
  'equipment',
  {
    list: () => import('../presentation/pages/EquipmentPage'),
    details: () => import('../presentation/pages/EquipmentDetails')
  },
  [
    { path: '', pageKey: 'list' },
    { path: 'create', pageKey: 'details' },
    { path: ':id', pageKey: 'details' }
  ]
);

export default EquipmentRoutes;
